import React, { useEffect, useState } from 'react'

import { WrapWindow } from '../../components/WrapWindow';
import { Button } from '../../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { updateOrderColors } from '../../redux/settingSlice';

const OrderColor = ({type, label, value, setColorHandler}) => {

  return (
    <div className="order-color">
        <div><input type="color" id={type} value={value} onChange={(e) => setColorHandler(e.target.value)} /></div>
        <label htmlFor={type}>{label}</label>
    </div>
  )
}

export const ColorSettings = ({colorState, setColorState}) => {
  const dispatch = useDispatch();
  const orderTypes = [
    {type: 'not-accepted', label: 'Не назначена'}, {type: 'process', label: 'В процессе'},
    {type: 'cancel', label: 'Отмена'}, {type: 'done', label: 'Готова'},
    {type: 'modern', label: 'Модерн'}, {type: 'warranty', label: 'Гарантия'},
    {type: 'reject', label: 'Готова в 0'},
  ]

  const setColorHandlerCreate = (type) => (color) => {
    setColorState(prev => prev.map(c => c.type === type ? ({type, color, _id: c._id}) : c))
  }
  const currentState = useSelector(state => state.settings.orderColors);
  const curStateString = [...currentState].sort((a,b)=>a.type.localeCompare(b.type)).map(c=>c.color).join('');
  const newStateString = [...colorState].sort((a,b)=>a.type.localeCompare(b.type)).map(c=>c.color).join('');
  const isChanged = curStateString !== newStateString;
  function changeColors() {
    dispatch(updateOrderColors(colorState.map(({_id, ...rest}) => rest)));
  }

  return (
    <WrapWindow
      showScroll={false}
      style={{flex: '0 0 auto'}}
      title="Настройка цветов"
      body={<div className='order-color-settings'>
        {orderTypes.map(ot => <OrderColor setColorHandler={setColorHandlerCreate(ot.type)} key={ot.type} label={ot.label} type={ot.type} value={colorState.find(c => c.type === ot.type)?.color} />)}
      </div>}
      footer={<>
      <Button disabled={!isChanged} text={isChanged ? 'Сохранить настройки' : 'Нет изменений'} onClick={changeColors}/>
      <Button style={{marginLeft: '16px'}} disabled={!isChanged} text={'Сброс'} onClick={() => setColorState(currentState)}/>
      </>}
    />
  )
}
